import { graphql } from "@cappelendamm/crystallize-types/discovery/gql";
export const getContributorsByScidQuery = graphql(`
  query getContributorsByScidQuery($scids: [Float!]) {
    browse {
      bidragsyter(filters: { scid_number: { in: $scids } }) {
        hits {
          itemId
          scid: externalReference
          topics: topicPaths
          name
          fornavn
          etternavn
          bilde {
            url
            key
            altText
            caption
            width
            height
            meta
            topics
            focalPoint
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`);
export const findBooksByAuthorQuery = graphql(`
  query GetBooksByAuthor($authorItemId: String!, $after: String) {
    browse {
      bok(
        publicationState: [published]
        filters: {
          variants_bidragsyter_bidragsyter_bidragsyter_items_itemId: {
            equals: $authorItemId
          }
        }
        sorting: { variants_utgivelsesdato_timestamp: desc }
        pagination: { limit: 100, after: $after }
      ) {
        summary {
          hasMoreHits
          endToken
        }
        hits {
          variants {
            sku
            name
            utgivelsesdato
            bidragsyter {
              bidragsyter {
                rolle
                bidragsyter {
                  items {
                    itemId
                  }
                }
              }
            }

            anmeldelse {
              html: tekst(format: html)
              anmelder
              kilde
              terningkast
              terningkastUnit
              sprak
              lenke
              dato
            }
          }
        }
      }
    }
  }
`);
